import React from 'react';

import { MfaDevices } from '@/features/mfa/components/MfaDevices';
import { selectDevices, selectHasFetchedDevices } from '@/features/mfaDevices/selectors';

import { Spinner } from '@bypasslane/clover--web-lib-sprout-spinner';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const getTypeDetails = (device) => {
  switch (device.type) {
    case 'SMS': {
      return device.phone;
    }
    case 'EMAIL': {
      return device.email;
    }
    case 'PLATFORM': {
      return device.platform;
    }
    default: {
      return '';
    }
  }
};

export const useMfaDevices = () => {
  const devices = useSelector(selectDevices);
  const hasFetchedDevices = useSelector(selectHasFetchedDevices);
  const filteredDevices = Array.isArray(devices) ? devices : [];

  return {
    devices: filteredDevices,
    hasFetchedDevices
  };
};

export function MfaDevicesContainer({ isLoading = false }) {
  const { devices: mfaDevices, hasFetchedDevices: devicesLoaded } = useMfaDevices();

  if (isLoading) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  return (
    <MfaDevices
      devices={mfaDevices}
      getTypeDetails={getTypeDetails}
      devicesLoaded={devicesLoaded}
    />
  );
}

export default MfaDevicesContainer;
MfaDevicesContainer.propTypes = {
  isLoading: PropTypes.bool
};
MfaDevicesContainer.displayName = 'MfaDevicesContainer';
